import { MenuItem } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

const SelectItemsLoader: React.FC = () => {
  return (
    <MenuItem disableRipple disabled>
      <CircularProgress size={20}  />
    </MenuItem>
  );
};

export default SelectItemsLoader;
